import { ArtsApiRemoteService } from '../../Services/api/arts/arts-service'
import { IArtByCustomerIdPayload, IArtsByCustomerListRepsonse } from '../../Services/api/arts/arts.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListArtsByCustomerUseCase
implements IFormUsecase<IArtByCustomerIdPayload, IArtsByCustomerListRepsonse> {
  constructor (private readonly ArtsApi: ArtsApiRemoteService) {}
    

  public async handle (
    data: IArtByCustomerIdPayload
  ): Promise<Result<IArtsByCustomerListRepsonse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ArtsApi.listByCustomer(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
